module.exports = __webpack_public_path__ + "static/media/ingham-institute.d2792820.png";